export enum CompanyTypeEnum {
  school = 'School',
}
